document.addEventListener('DOMContentLoaded', () => {

  const $headerContent = $('#header-content');
  const $headerAccount = $('.header-account-content');
  const $header = $('.navbar');

  function showMenuContent(item, slideDown) {
    $headerAccount.removeClass('active');
    item.addClass('active');
    const href = item.children('a').data('href');
    $('.header-items li:not([id="' + item.attr('id') + '"])').removeClass('active');
    $('.header-content-tab:not([id="' + href + '"])').hide();

    const content = $('#' + href);
    content.show();

    if (slideDown) {
      $headerContent.slideDown();
    } else {
      $headerContent.show();
    }
  }

  // Hide the submenu when I click outside of it.
  $('html').on('click', function () {
    if ($headerContent.is(':visible') && !$headerContent.is(':hover')) {
      $headerContent.slideUp();
      $('.header-items li.active').removeClass('active');
    }
    if ($headerAccount.is(':visible') && !$('#header-account-info').is(':hover')) {
      $headerAccount.removeClass('active');
    }
  });

  $('.header-submenu-items a').on('click', () => {
    $headerContent.slideUp();
    $('.header-items li.active').removeClass('active');
  })

  $('.header-items li.hasChildren:not(#header-account-info)').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const parent = $(this);
    if (parent.hasClass('active')) {
      $headerContent.slideUp();
      parent.removeClass('active');
    } else {
      showMenuContent(parent, true);
    }
  });

  $('.header-account-toggle').on('click', () => $headerAccount.toggleClass('active'));

  const mobileCollapse = $('#navbar-mobile-collapse');
  mobileCollapse.find('ul>li a').on('click', () => mobileCollapse.collapse('hide'));

  const headerItemSearchBox = $('.header-item-search-box');
  const searchMenu = document.getElementById('search-term_menu');
  const searchForm = document.getElementById('search_form');
  const searchInput = document.getElementById('id__search_term');
  const $searchInput = $('#id__search_term');
  
  function showSearchBar() {
    headerItemSearchBox.addClass('show');
  }

  function hideSearchBar(e) {
    const isSearchInputFocused = $searchInput.is(":focus");

    if (
      e && e.target && !isSearchInputFocused &&
      ((searchMenu && !searchMenu.contains(e.target)) || 
      (searchInput && !searchInput.contains(e.target)) || 
      (searchForm && !searchForm.contains(e.target)))
    ) {
      headerItemSearchBox.removeClass('show');
    }
  }

  if (searchInput) $searchInput.blur(() => {
    window.addEventListener('click', function(e) {
      hideSearchBar(e);
    });
  });
  
  headerItemSearchBox.hover(showSearchBar, hideSearchBar);
  headerItemSearchBox.click(showSearchBar);


  (() => {
    const scrollUpListener = (header) => {
      let lastScrollTop = 0;

      return () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop && scrollTop > $header.outerHeight()) {
          header.addClass('hide');
        } else {
          header.removeClass('hide');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      };
    };

    if (window.DISABLE_STICKY_HEADER) {
      $header.removeClass('fixed-top');
    } else {
      window.addEventListener('scroll', scrollUpListener($('.navbar')), { capture: true, passive: true });
    }
  })();
});
